import get from 'lodash/get';

export default function getPentagramFromState(state: object): string {
  return get(state, 'page.data.region.pentagram', '');
}
